export const ConsentStatusNames: { [key: number]: string } = {
  1: 'ACTIVE',
  2: 'Inactive',
};

export enum StudentConsentStatusCodes {
  Incomplete,
  Complete,
}

export const ConsentStatus: { [key: string]: number } = {
  Active: 1,
  Inactive: 2,
  Deleted: 3,
};

export const ConsentStatusChoices = [
  { name: 'Active', value: ConsentStatus['Active'] },
  { name: 'Inactive', value: ConsentStatus['Inactive'] },
  { name: 'Delete', value: ConsentStatus['Deleted'] },
];

export const ConsentTypes: { [key: string]: number } = {
  Ministry: 1,
  Pathways: 2,
  'School Board': 3,
};

export const ConsentTypesNames: { [key: number]: string } = {
  0: 'Unknown',
  1: 'Ministry',
  2: 'Pathways',
  3: 'School Board',
};
